// Shared metadata for the Complaints / Resolution Centre.

export const CATEGORIES = [
  { value: "order_not_received", label: "Order not received", group: "Order issues" },
  { value: "item_not_as_described", label: "Item not as described", group: "Order issues" },
  { value: "fake_item", label: "Fake / counterfeit item", group: "Order issues" },
  { value: "refund_request", label: "Refund request", group: "Order issues" },
  { value: "scam", label: "Scam / fraud", group: "Order issues" },
  { value: "harassment", label: "Harassment", group: "User behaviour" },
  { value: "abuse", label: "Abusive behaviour", group: "User behaviour" },
  { value: "prohibited_item", label: "Prohibited / illegal item", group: "Listing issues" },
  { value: "counterfeit_listing", label: "Counterfeit listing", group: "Listing issues" },
  { value: "misleading_listing", label: "Misleading listing", group: "Listing issues" },
  { value: "other", label: "Other", group: "Listing issues" },
];

export const STATUS_META = {
  open: { label: "Open", color: "bg-[#D9923B]/15 text-[#D9923B]" },
  responded: { label: "Awaiting you", color: "bg-[#233348]/10 text-[#233348]" },
  escalated: { label: "Escalated", color: "bg-[#C05A3C]/15 text-[#C05A3C]" },
  resolved: { label: "Resolved", color: "bg-[#4A5D23]/15 text-[#4A5D23]" },
  rejected: { label: "Rejected", color: "bg-[#5C5852]/15 text-[#5C5852]" },
  withdrawn: { label: "Withdrawn", color: "bg-[#5C5852]/15 text-[#5C5852]" },
};

export const RESOLUTIONS = [
  { value: "refund_issued", label: "Refund issued" },
  { value: "refund_denied", label: "Refund denied" },
  { value: "warning_issued", label: "Warning issued to respondent" },
  { value: "listing_removed", label: "Listing removed" },
  { value: "user_suspended", label: "User suspended" },
  { value: "no_action", label: "No action / dismissed" },
];

export const categoryLabel = (val) =>
  CATEGORIES.find((c) => c.value === val)?.label ||
  (val || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const formatWhen = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
    return d.toLocaleDateString();
  } catch {
    return iso;
  }
};
